import { render, staticRenderFns } from "./InvoiceTexts.vue?vue&type=template&id=67bc5239&scoped=true"
import script from "./InvoiceTexts.vue?vue&type=script&lang=js"
export * from "./InvoiceTexts.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTexts.vue?vue&type=style&index=0&id=67bc5239&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc5239",
  null
  
)

export default component.exports